
import './errorComponent.css';

function ErrorComponent({error}) {
  return (
    <div className='box-error'>{error}</div>
  )
}

export default ErrorComponent
